module.exports = __webpack_public_path__ + "img/team_1_index.be84bf25.png";